<template>
	<a-row>
		<a-col :span="5">
			<a-card class="cardImp" :bordered="false" :loading="cardLoading">
				<a-tree v-if="treeData.length > 0" v-model:expandedKeys="defaultExpandedKeys" :tree-data="treeData" :field-names="treeFieldNames" @select="treeSelect"> </a-tree>
				<a-empty v-else :image="Empty.PRESENTED_IMAGE_SIMPLE" />
			</a-card>
		</a-col>
		<a-col :span="19">
			<a-card :bordered="false">
				<SearchForm :form-state="searchFormState" :form-fields="[{ label: '名称关键词', name: 'searchKey', span: 8 }]" @search="table.refresh(true)" @reset="handleReset" ref="searchFormRef">
					<template #searchKey="{ formState }">
						<a-input v-model:value="formState.searchKey" placeholder="请输入职位名称关键词" />
					</template>
				</SearchForm>
				<s-table
					ref="table"
					:columns="columns"
					:data="loadData"
					:expand-row-by-click="true"
					:alert="options.alert.show"
					bordered
					:row-key="(record) => record.id"
					:row-selection="options.rowSelection"
					:operator-config="operatorConfig"
				>
					<template #bodyCell="{ column, record }">
						<template v-if="column.dataIndex === 'category'">
							{{ $TOOL.dictTypeData('POSITION_CATEGORY', record.category) }}
						</template>
						<template v-if="column.dataIndex === 'action'">
							<a @click="form.onOpen(record)">编辑</a>
							<a-divider type="vertical" />
							<a-popconfirm title="确定删除此职位？" @confirm="removeOrg(record)">
								<a-button type="link" danger size="small">删除</a-button>
							</a-popconfirm>
						</template>
					</template>
				</s-table>
			</a-card>
		</a-col>
	</a-row>
	<Form ref="form" @successful="table.refresh(true)" />
</template>
<script setup name="sysPositionIndex">
	import { message, Empty } from 'ant-design-vue'
	import positionApi from '@/api/sys/positionApi'
	import orgApi from '@/api/sys/orgApi'
	import Form from './form.vue'
	const columns = [
		{
			title: '职位名称',

			dataIndex: 'name'
		},
		{
			title: '分类',

			dataIndex: 'category'
		},
		{
			title: '排序',

			dataIndex: 'sortCode'
		},
		{
			title: '操作',

			dataIndex: 'action',
			align: 'center',
			width: 150
		}
	]
	let selectedRowKeys = ref([])
	// 列表选择配置
	const options = {
		alert: {
			show: false,
			clear: () => {
				selectedRowKeys = ref([])
			}
		},
		rowSelection: {
			onChange: (selectedRowKey, selectedRows) => {
				selectedRowKeys.value = selectedRowKey
			}
		}
	}
	// 定义tableDOM
	const table = ref(null)
	const form = ref()
	const searchFormRef = ref()
	let searchFormState = reactive({})
	// 默认展开的节点
	let defaultExpandedKeys = ref([])
	const treeData = ref([])
	// 替换treeNode 中 title,key,children
	const treeFieldNames = { children: 'children', title: 'name', key: 'id' }
	const cardLoading = ref(true)
	// 表格查询 返回 Promise 对象
	const loadData = (parameter) => {
		return positionApi.positionPage(Object.assign(parameter, searchFormState)).then((res) => {
			return res
		})
	}
	// 操作按钮配置
	const operatorConfig = computed(() => [
		{
			text: '新增',
			icon: 'fa fa-plus',
			onClick: () => form.value.onOpen(),
			visible: true
		},
		{
			text: '删除',
			icon: 'fa fa-trash',
			danger: true,
			onClick: deleteBatchPosition,
			disabled: selectedRowKeys.value.length === 0,
			visible: true
		}
	])
	// 重置表单
	const handleReset = () => {
		searchFormRef.value?.resetFields()
	}
	// 加载左侧的树
	orgApi.orgTree().then((res) => {
		cardLoading.value = false
		if (res !== null) {
			treeData.value = res
			// 默认展开2级
			treeData.value.forEach((item) => {
				// 因为0的顶级
				if (item.parentId === '0') {
					defaultExpandedKeys.value.push(item.id)
					// 取到下级ID
					if (item.children) {
						item.children.forEach((items) => {
							defaultExpandedKeys.value.push(items.id)
						})
					}
				}
			})
		}
	})
	// 点击树查询
	const treeSelect = (selectedKeys) => {
		if (selectedKeys.length > 0) {
			searchFormState.orgId = selectedKeys.toString()
		} else {
			delete searchFormState.orgId
		}
		table.value.refresh(true)
	}
	// 删除
	const removeOrg = (record) => {
		let params = [
			{
				id: record.id
			}
		]
		positionApi.positionDelete(params).then(() => {
			table.value.refresh(true)
		})
	}
	// 批量删除
	const deleteBatchPosition = () => {
		if (selectedRowKeys.value.length < 1) {
			message.warning('请选择一条或多条数据')
			return false
		}
		const params = selectedRowKeys.value.map((m) => {
			return {
				id: m
			}
		})
		positionApi.positionDelete(params).then(() => {
			table.value.clearRefreshSelected()
		})
	}
</script>
<style scoped>
	.cardImp {
		margin-right: 10px;
	}
	.ant-form-item {
		margin-bottom: 0 !important;
	}
	.primaryAdd {
		margin-right: 10px;
	}
	.snowy-buttom-left {
		margin-left: 8px;
	}
</style>
